import {XauditModel} from "../../../../../models/xaudit.model";

export class EndoDiagnosisPriorTreatmentDataModel extends XauditModel{
  EndoDiagPriorTretmentID: string;
  EndoDiagID: string;
  enumDiagTreatID: string;
  TreatmentDate: string;
  TreatingDoctor: string = '';
  enumDiagTreatmentTypeID: string;
  isSVE: boolean;
}
